import { LoaderFunctionArgs, ShouldRevalidateFunction, redirect } from "react-router";
import { fetchAiChatMessages } from "redux/slices/lensEditor";
import store from "redux/store";

export const aiChatLoader = async (args: LoaderFunctionArgs) => {
  const chatId = args.params.chatId || "";
  const lensId = parseInt(args.params.lensId || "");

  if (!chatId || isNaN(lensId)) {
    return redirect("..");
  }

  return await store
    .dispatch(fetchAiChatMessages({ lensId, chatId }))
    .then((value) => value.payload)
    .catch(() => {
      return redirect("..");
    });
};

export const shouldRevalidateAiChat: ShouldRevalidateFunction = (params) => {
  const { currentParams, nextParams } = params;
  return currentParams.chatId !== nextParams.chatId;
};
